import {OnBoardingTooltipModel} from "../on-boarding-tooltip.model";
import {IOnBoardingTooltipsContainer} from "../on-boarding-tooltips-container.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import React from "react";
import {stickToBottomTooltipModifier} from "../../tooltip-base/tooltip-modifiers";
import {
    IosAddToHomeScreenComponent
} from "../../../../components/tooltip/tooltips/ios-add-to-home/ios-add-to-home.component";
import {makeObservable, observable, reaction} from "mobx";
import {OrbitUserFlowAnalyticsCategory} from "../../../analytics/analytics.service.interface";

export class IosPwaOnBoardingTooltipModel extends OnBoardingTooltipModel {
    constructor(tooltipsContainer: IOnBoardingTooltipsContainer,
                services: IServiceFactoryExtended) {

        super(tooltipsContainer, services, {
            renderContent: () => (<IosAddToHomeScreenComponent
                                  brandName={services.sdk.getSkin().getBrandName()}
                                  onClicked={this._onToolTipClick} />),
            localStorageKey: 'ios-pwa_on_boarding_tooltip',
            maximumDisplayCount: 2,
            styling: {
                textColor: "black",
                backgroundColor: "white",
                borderColor: "transparent"
            },
            modifiers: [stickToBottomTooltipModifier],
            placement: "bottom",
            showCloseButton: true,
            invertCloseButtonColors: true,
            closeOnClickOutside: true,
            showOverlay: false,
            hasGlow: false,

        });

        makeObservable(this);

        reaction(() => this.services.gameRunner.currentRunningGame,
            (currentRunningGame) => {
                if(currentRunningGame) {
                    this._openGameCount++;
                }
            });

        reaction(() => this.services.user.isAuthorized ,
            () => {
               this._openGameCount = 0;
            });
    }


    @observable.ref
    private _openGameCount: number = 0;

    protected _getElementToAttach(): HTMLElement | null {
        return this.services.dom.body;
    }

    shouldDisplay(): boolean {
        const commonConditions = super.shouldDisplay();
        const isDeviceEligible = this._isDeviceEligible;
        return this._openGameCount > 0
                && isDeviceEligible
                && commonConditions;
    }

    private get _isDeviceEligible(): boolean {
        const device = this.services.device;

        // we must show tooltip on iPhone Safari and not standalone which means shortcut app opened browser
        if (!device.model.isIphone)
            return false;
        if (!device.browser.isSafari)
            return false;
        if (device.isStandalone)
            return false;

        const extraProps = this.services.configuration.startupConfiguration.sdk.config.ExtraProperties;
        if (!extraProps.pwaEnabled)
            return false;
        if (device.hybrid.isHybrid)
            return false;

        if (this.services.miniOrbit.isEnabled)
            return false;

        return true;
    }

    private _onToolTipClick = () => {
        this.closeTooltip();
    }

    closeTooltip() {
        super.closeTooltip();
        this.services.analytics.sendOrbitUserFlowEvent(OrbitUserFlowAnalyticsCategory.PWA, 'Banner_Prompt', 'Closed');
    }

    onToolTipRendered(tooltipContainer: HTMLElement) {
        super.onToolTipRendered(tooltipContainer);
        this.services.analytics.sendOrbitUserFlowEvent(OrbitUserFlowAnalyticsCategory.PWA, 'Banner_Prompt', 'SHOW');

    }
}